import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20artistic%20overhead%20flat%20lay%20collage%20of%20diverse%20fashion%20products%20including%20sneakers%20hoodies%20watches%20bags%20and%20accessories%20arranged%20in%20an%20organic%20flowing%20composition%20on%20warm%20cream%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20editorial%20lifestyle%20photography%2C%20gentle%20warm%20shadows%2C%20harmonious%20muted%20earth%20tones%2C%20clean%20minimal%20aesthetic%2C%20no%20faces&width=1800&height=1350&seq=hero-collage-v2-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/20"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="w-full lg:w-[45%] text-center lg:text-left">
            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-[1.1] tracking-tight">
              The Ultimate <span className="text-accent-300">Hipobuy Spreadsheet</span> Shopping Guide
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-200 leading-relaxed max-w-[55ch] mx-auto lg:mx-0">
              Discover organized Hipobuy spreadsheets, verified product finds, QC guides, price comparisons, and expert buying strategies — all in one place.
            </p>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <div ref={dropdownRef} className="relative w-full sm:w-auto">
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="w-full sm:w-64 flex items-center justify-between gap-3 px-5 py-3.5 bg-background-50/90 backdrop-blur-sm border border-background-200/60 rounded-2xl text-sm font-medium text-foreground-700 hover:border-primary-300 transition-all duration-200 cursor-pointer"
                >
                  <span>Select a category</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
                  </div>
                </button>
                {dropdownOpen && (
                  <div className="absolute top-full mt-2 left-0 right-0 sm:w-64 bg-background-50 border border-background-200/70 rounded-2xl shadow-lg overflow-hidden z-40 max-h-72 overflow-y-auto">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        onClick={() => setDropdownOpen(false)}
                        className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap"
                      >
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-base`}></i>
                        </div>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                Hipobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-4 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                Buy It Now
              </a>
            </div>

            <p className="mt-5 text-sm text-background-300">
              Helping thousands of shoppers find better products with organized spreadsheet resources and detailed buying guides.
            </p>
          </div>

          <div className="hidden lg:block w-full lg:w-[55%]"></div>
        </div>
      </div>
    </section>
  );
}